import React, { Component } from 'react'
import { getDefaultEINByCompanyID, getCPReport, payrollDetailAction, CertifiedJobCC } from "../../store/actions";
import { getCertifiedSettings } from "../../store/actions/Admin/certifiedPayrollSettings";
import orderBy from "lodash/orderBy";
import { connect } from "react-redux";
import Select from "react-select";
import { subYears, format, endOfWeek, subWeeks } from "date-fns";
import Loader from '../../components/loader';
import ReportDateRange from '../../components/reportDateRange'
import { tableTemplates } from '../../utils/constants';
import Export_PDF from '../../assets/images/export-pdf.png';
import { Tooltip } from 'react-bootstrap';
import Export_Excel from '../../assets/images/export-excel-24.png';

const getSelectStyles = (width = '200px') => ({
    control: (provided, state) => ({
        ...provided,
        width: width,
        margin: '0px',
        borderColor: state.isFocused ? '#47E5EB' : '#ccc',
        boxShadow: state.isFocused ? '0 0 0 1px #47E5EB' : null,
        '&:hover': {
            borderColor: state.isFocused ? '#47E5EB' : '#ccc'
        }
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#47E5EB' : 'white',
        color: state.isSelected ? 'white' : 'black',
        '&:hover': {
            backgroundColor: state.isSelected ? '#47E5EB' : '#46e6ec33'
        },
    })
});


class CertifiedPayroll extends Component {
    constructor(props) {
        super(props);
    };

    runReportOptions = [
        {
            label: "Payroll",
            value: "payroll"
        },
        {
            label: "Job & Date Range",
            value: "job"
        }
    ];

    state = {
        loading: true,
        selectOptions: [],
        jobList: [],
        tableOptions: [],
        displayJobSearch: false,
        displayPayrollSearch: false
    };

    getLastPayrolls = async () => {
        let startDate = format(subYears(new Date(), 3), "MM-dd-yyyy");
        await this.props.payrollDetailAction(this.props.UserReducer.company, { startDate, payrollType: { $in: ["Regular", "Historical"] } });
        return this.props.PayrollReducer;
    };

    runReport = async (company, payrollId, runBy, tableTemplate, ccJobName, startDate, endDate, selectedReportType) => {

        this.setState({ loading: true, reportUrl: undefined, selectedReportType });
        let res = await getCPReport(company, payrollId, runBy, tableTemplate, ccJobName, startDate, endDate, selectedReportType);
        const url = window.URL.createObjectURL(new Blob([res.data],
            {
                type: selectedReportType === 'xls' ?
                    'application/vnd.ms-excel' :
                    'application/pdf'
            }));

        if (selectedReportType === 'xls') {
            var link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `certified-payroll-${this.state.selectedOption.label}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        //window.open(url);
        this.setState({ loading: false, reportUrl: url });
    }

    handleChanges = selectedOption => {
        this.setState({ selectedOption });
    };

    handleSelectJob = selectedJob => {
        this.setState({ selectedJob });
    };

    handleSelectRange = range => {
        if (!range) return;
        this.setState({ selectedRange: range, })
        if (range.group !== 'Custom') {
            this.handleDateRange(range.from, range.to);
        };
    };

    handleDateRange = (startDate, endDate) => {
        this.setState({ startDate, endDate });
    };

    selectRunReportBy = selected => {
        this.setState({ runBy: selected });
    };

    handleSelectTemplate = selected => {
        this.setState({ selectedTemplate: selected });
    };

    async componentDidMount() {
        await this.props.getCertifiedSettings(this.props.UserReducer.company);
        let { costCenterTreeName: treeName, certifiedJobField: certifiedField, tableTemplate } = this.props.CertifiedPayrollReducer;
        let tableOptions = tableTemplates.filter(tt => tableTemplate?.includes(tt.value));
        await this.props.CertifiedJobCC(this.props.UserReducer.company, certifiedField, treeName);
        const SelectOptions = await this.getLastPayrolls();
        let selectOptions = orderBy(SelectOptions?.reduce((memo, payroll) => {
            memo.push({
                label: payroll.payrollName,
                value: payroll.payrollSystemId,
                date: payroll.payPeriodEnd
            });
            return memo;
        }, []), elem => Date.parse(elem.date), "desc");
        let endDate = endOfWeek(subWeeks(new Date(), 1));
        let startDate = subWeeks(endDate, 2);
        this.setState({
            selectOptions,
            loading: false,
            tableOptions,
            selectedTemplate: tableOptions[0],
            jobList: this.props.GET_CERTIFIED_JOB_CC.map(cc => ({ label: cc.name, value: cc.id })),
            startDate, endDate,
            runBy: this.runReportOptions[0]
        });
    }


    render() {
        let { selectedOption, loading,
            reportUrl, selectedJob,
            startDate, endDate, runBy,
            displayJobSearch, jobList,
            tableOptions, selectedTemplate,
            selectedReportType
        } = this.state;
        if (!selectedOption) selectedOption = this.state.selectOptions[0];
        return (
            <div className="df ffc wp_report_page" style={{ height: "100%" }}>
                <div className="df download_actns">
                    <div className="mla"></div>
                </div>
                <div className="df filters_wrpr mb-5" >
                    <div className='ps-1' style={{ padding: '5px' }}>
                        <Select
                            placeholder="Run Report By:"
                            options={this.runReportOptions}
                            value={runBy}
                            onChange={this.selectRunReportBy}
                            styles={getSelectStyles()}
                        >
                        </Select>
                    </div>
                    {runBy?.value === 'job' ? (<>
                        <div className='ps-1' style={{ width: '300px', padding: '5px' }}>
                            <Select
                                placeholder={displayJobSearch ? "Start typing to search jobs" : "Select Certified Job"}
                                options={jobList}
                                value={selectedJob}
                                styles={getSelectStyles('auto')}
                                onMenuOpen={() => this.setState({ displayJobSearch: true })}
                                onMenuClose={() => this.setState({ displayJobSearch: false })}
                                onChange={this.handleSelectJob}>
                            </Select>
                        </div>
                        <ReportDateRange
                            startDate={startDate}
                            endDate={endDate}
                            handleDateRange={this.handleDateRange}
                            handleSelect={this.handleSelectRange}
                            style={{
                                container: {
                                    padding: '5px',
                                }
                            }}
                        ></ReportDateRange>
                    </>) : (
                        <div className='ps-1' style={{ width: '250px', padding: '5px' }}>
                            <Select
                                placeholder={this.state.displayPayrollSearch ? "Start typing to search payrolls" : ""}
                                options={this.state.selectOptions}
                                value={selectedOption}
                                onChange={this.handleChanges}
                                styles={getSelectStyles('auto')}
                                onMenuClose={() => this.setState({ displayPayrollSearch: false })}
                                onMenuOpen={() => this.setState({ displayPayrollSearch: true })}
                            >
                            </Select>
                        </div>)}
                    {tableOptions.length > 1 ? (
                        <div className='ps-1' style={{ width: '300px', padding: '5px' }}>
                            <Select
                                options={tableOptions}
                                defaultValue={tableOptions[0]}
                                value={selectedTemplate}
                                styles={getSelectStyles('auto')}
                                onChange={this.handleSelectTemplate}>
                            </Select>
                        </div>
                    ) : ("")

                    }
                    <div className="df mla" style={{ padding: '5px' }}>
                        {runBy?.value === 'payroll' ?
                            <button
                                className='ag-header-icon ag-export-icon'
                                disabled={!this.state.selectOptions}
                                title='Run Excel'
                                onClick={() => {
                                    this.runReport(this.props.UserReducer.company, selectedOption.value, runBy?.value, selectedTemplate.value, selectedJob?.value, startDate, endDate, "xls");
                                }}
                            >
                                <img src={Export_Excel} />
                            </button> : ""}
                        <button
                            className="ag-header-icon ag-export-icon"
                            disabled={!this.state.selectOptions}
                            onClick={() => {
                                this.runReport(this.props.UserReducer.company, selectedOption.value, runBy?.value, selectedTemplate.value, selectedJob?.value, startDate, endDate, "pdf");
                            }}
                            title='Run PDF Report'
                        >
                            <img src={Export_PDF} alt="PDF Report" />
                        </button>
                    </div>
                </div>

                <div style={{ height: "100%", width: "100%" }}>
                    {loading ? (
                        <div style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "75%"
                        }}>
                            <h3>Preparing your report...</h3>
                            <h4>Please wait...</h4>
                            <div className="ec_setup_contact df acc loading">
                                <Loader></Loader>
                            </div>
                        </div>

                    ) : (
                        <>
                            {!loading && reportUrl && selectedReportType !== 'xls' && <object data={reportUrl} width="100%" height="100%"></object>}
                            {!loading && !reportUrl && <div className="df acc table_wrpr" style={{ height: "100%" }}>
                                <p style={{ fontSize: "24px" }}>
                                    Please click RUN to generate the report
                                </p>
                            </div>}
                        </>
                    )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ UserReducer, EINReducer, PayrollReducer, CertifiedPayrollReducer, CostCenterReducer }) => {
    let { GET_CERTIFIED_JOB_CC } = CostCenterReducer;
    return { UserReducer, EINReducer, PayrollReducer, CertifiedPayrollReducer, GET_CERTIFIED_JOB_CC }
};

export default connect(mapStateToProps, {
    getDefaultEINByCompanyID,
    payrollDetailAction,
    getCertifiedSettings,
    CertifiedJobCC
})(CertifiedPayroll);